import React from "react";
import styles from "./SocialResponsibility.module.css";

const socialProjects = [
  {
    name: "Beteabrham",
    description: "Website development for Beteabrham provided as a free, voluntary service.",
    icon: "fa-hands-helping",
    website: "https://beteabrham.org/"
  },
  {
    name: "Mahibere Yohannes",
    description: "Website development for Mahibere Yohannes provided as a free, voluntary service.",
    icon: "fa-hands-helping",
    website: "https://mahibereyohannes.org/"
  }
];


const SocialResponsibility = () => (
  <div className="container-fluid py-5 bg-light">
    <div className="container py-5">
      <div className="text-center mb-5" data-aos="fade-up">
        <h5 className="sub-title" style={{ color: "#A71717" }}>SOCIAL RESPONSIBILITY</h5>
        <h1 className="display-5 mb-3" style={{ color: "#A71717" }}>Giving Back to the Community</h1>
        <p className="text-muted">We believe in making a positive impact through volunteering and pro-bono services.</p>
      </div>
      <div className="row g-4 justify-content-center">
        {socialProjects.map((project, idx) => (
          <div className="col-md-8 col-lg-6" key={idx}>
            <div className={styles["social-card"] + " text-center"}>
              <i className={`fas ${project.icon} ${styles["social-icon"]}`}></i>
              <h5 className={styles["social-title"]}>{project.name}</h5>
              <p>{project.description}</p>
              {project.website && (
                <a href={project.website} className={styles["social-link"]} target="_blank" rel="noopener noreferrer">
                  Visit Website
                </a>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  </div>
);

export default SocialResponsibility;
